import { render, staticRenderFns } from "./customersarchive0512-add-or-update.vue?vue&type=template&id=1175541b&"
import script from "./customersarchive0512-add-or-update.vue?vue&type=script&lang=js&"
export * from "./customersarchive0512-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports